import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';
import SeoHreflang from '../components/SeoHreflang';
import logo_rus from '../assets/logo_rus.png';
import logo_eng from '../assets/logo_eng.png';
import logo_esp from '../assets/logo_esp.png';
import logo_zh from '../assets/logo_zh.png';
import i18n from "../i18n";
import { Link } from "react-router-dom";
import SiteHeader from '../components/SiteHeader';
import footerDoc1 from '../assets/footer-doc1.docx';
import footerDoc2 from '../assets/footer-doc2.docx';
const LanguageSwitcher = React.lazy(() => import('..//components/LanguageSwitcher'));


const BASE_ITEMS = [
  { type: 'link', label: 'Реестр готовых решений', path: 'registry' },
  { type: 'link', label: 'Обучение лучших практик', path: 'courses' },
  { type: 'link', label: 'Маркетплейс готовых решений', path: 'marketplace' },
  { type: 'link', label: 'Книга лучших практик', path: 'book' },
];

function ProductMenu() {
  const { lang } = useParams();        // <-- текущий язык из URL
  const currentLang = lang || 'ru';    // fallback

  const productItems = BASE_ITEMS.map(item => ({
    ...item,
    to: `/${currentLang}/${item.path}`, // <-- добавляем префикс
  }));

  return (
    <nav>
      {productItems.map(item => (
        <Link key={item.to} to={item.to}>{item.label}</Link>
      ))}
    </nav>
  );
}

/**
 * MarketplaceLanding.jsx — React + Tailwind компонент
 * Переносит разметку лендинга «{t('MP_ref1')}» в единый файл без внешнего CSS/JS.
 * Секции: Header • Hero • Proof • HowItWorks • Catalog • Trust • CaseTemplate • Testimonials • Referral (калькулятор) • {t('linkMP5')} • Footer • FloatingCTA
 */
export default function MarketplacePage() {
  const { t } = useTranslation();
  return (
    <div className="bg-white text-gray-900">
      <SeoHreflang />
      <Header />
      <Hero />
      <ProofNumbers />
      <HowItWorks />
      <CatalogTeaser />
      <Trust />
      <CaseTemplate />
      <Testimonials />
      <Referral />
      <Faq />
      <Footer />
      <FloatingCTA />
    </div>
  );
}

/* ===================== PRIMITIVES ===================== */
function Container({ className = "", children }) {
  return (
    <div className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>
  );
}

function Card({ className = "", children }) {
  return (
    <div className={`rounded-3xl border border-gray-200 bg-white p-6 ${className}`}>{children}</div>
  );
}

function BrandGrad({ className = "", children }) {
  return (
    <div className={`bg-gradient-to-r from-purple-600 to-indigo-600 ${className}`}>{children}</div>
  );
}

function Badge({ children }) {
  return (
    <div className="inline-flex items-center gap-1.5 rounded-full bg-zinc-100 px-2.5 py-1 text-[12px] text-zinc-700">{children}</div>
  );
}

function Reveal({ children }) {
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          setShow(true);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={`transition-all duration-500 will-change-transform ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}
    >
      {children}
    </div>
  );
}

/* ===================== HEADER ===================== */
function Header() {
  const logoMap = { ru: logo_rus, en: logo_eng, es: logo_esp, zh: logo_zh };
  const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
  const currentLogo = logoMap[lang] || logo_eng;
  const { t } = useTranslation();
  return (
    

<SiteHeader
  pageLinks={[
    { label: t('ButtonMP8'), href: '#how' },
    { label: t('linkMP5'), href: '#faq' },
  ]}
  cta={[{ label: t('ButtonMP6'), to: '/login' }]}
/>

    // <header className="sticky top-0 z-40 border-b border-gray-100 bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/70">
    //   <Container className="h-16 flex items-center justify-between">
    //     <Link to="/" style={{height: '100%'}}>
    //           <img src={currentLogo} style={{ height: '100%', width: 'auto' }} alt="logo"/>
    //     </Link>
    //     <nav className="hidden md:flex items-center gap-6 text-sm">
    //       <a href="#solutions" className="hover:text-indigo-600">{t('linkMP1')}</a>
    //       <a href="#how" className="hover:text-indigo-600">{t('ButtonMP8')}</a>
    //       <a href="#proof" className="hover:text-indigo-600">{t('linkMP3')}</a>
    //       <a href="#ref" className="hover:text-indigo-600">{t('linkMP4')}</a>
    //       <a href="#faq" className="hover:text-indigo-600">{t('linkMP5')}</a>
    //     </nav>
    //     <div className="hidden sm:flex items-center gap-2">
    //       <a href="#find" className="inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold bg-gray-900/5 hover:bg-gray-900/10 transition">{t('ButtonMP3')}</a>
    //       <a href="#publish" className="inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold text-white bg-gradient-to-r from-purple-600 to-indigo-600 hover:opacity-90 transition">{t('ButtonMP6')}</a>
    //     </div>
    //     <ProductMenu />
    //     <LanguageSwitcher />
    //   </Container>
    // </header>
  );
}

/* ===================== HERO ===================== */
function Hero() {
  const { t } = useTranslation();
  const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
  return (
    <section className="relative overflow-hidden">
      {/* soft blobs */}
      <div className="pointer-events-none absolute inset-0" aria-hidden>
        <div className="absolute -right-24 -top-24 h-64 w-64 rounded-full bg-purple-100 blur-3xl opacity-60" />
        <div className="absolute -left-24 -bottom-24 h-64 w-64 rounded-full bg-indigo-100 blur-3xl opacity-60" />
      </div>

      <Container className="py-16">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <Reveal>
            <div className="inline-flex items-center gap-2 rounded-full border border-gray-200 px-3 py-1 text-xs text-gray-600 mb-4">
              <span className="inline-block h-2 w-2 rounded-full bg-indigo-600" /> {t('Subheader30')}
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold leading-tight tracking-tight">
              <Trans 
              i18nKey="Header25"
              components={{ span: <span className="bg-gradient-to-r from-purple-600 to-indigo-600 bg-clip-text text-transparent" /> }}
              />
            </h1>
            <p className="mt-4 text-lg text-gray-700">
              {t('Subheader31')}
            </p>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm text-gray-700">
              <Badge>✅ {t('Subheader311')}</Badge>
              <Badge>✅ {t('Subheader312')}</Badge>
              <Badge>✅ {t('Subheader313')}</Badge>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a id="find" href={`/login`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center rounded-2xl px-6 py-3 text-base font-semibold text-white bg-gradient-to-r from-purple-600 to-indigo-600 hover:opacity-90 transition shadow-[0_12px_40px_rgba(24,24,27,.08)]">{t('ButtonMP3')}</a>
              <a href="#how" className="inline-flex items-center justify-center rounded-2xl px-6 py-3 text-base font-semibold bg-gray-900/5 hover:bg-gray-900/10 transition">{t('ButtonMP4')}</a>
            </div>
          </Reveal>

          <Reveal>
            <Card className="shadow-[0_12px_40px_rgba(24,24,27,.08)]">
              <BrandGrad className="rounded-2xl p-5 text-white">
                <div className="text-sm opacity-90">{t('Subheader32')}</div>
                <div className="text-2xl font-bold leading-tight">{t('Header26')}</div>
              </BrandGrad>
              <div className="mt-4 grid grid-cols-2 gap-4 text-sm">
                <InfoTile title={t('PackEx1')} text={t('PackEx11')} />
                <InfoTile title={t('PackEx3')} text={t('PackEx31')} />
                <InfoTile title={t('PackEx2')} text={t('PackEx21')} />
                <InfoTile title={t('PackEx4')} text={t('PackEx51')} />
              </div>
            </Card>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}

function InfoTile({ title, text }) {
  return (
    <div className="rounded-2xl bg-gray-50 p-4">
      <div className="font-semibold">{title}</div>
      <div className="mt-1 text-gray-600">{text}</div>
    </div>
  );
}

/* ===================== PROOF NUMBERS ===================== */
function ProofNumbers() {
  const { t } = useTranslation();
  return (
    <section id="proof">
      <Container className="pb-12">
        <Reveal>
          <div className="grid gap-4 text-center sm:grid-cols-3">
            <Stat n={t('Subheader33')} label={t('Subheader331')} />
            <Stat n="12" label={t('Subheader341')} />
            <Stat n={t('Subheader35')} label={t('Subheader351')} />
          </div>
        </Reveal>
      </Container>
    </section>
  );
}

function Stat({ n, label }) {
  return (
    <div className="rounded-3xl border border-gray-200 bg-white p-6">
      <div className="text-3xl font-extrabold">{n}</div>
      <div className="mt-1 text-sm text-gray-600">{label}</div>
    </div>
  );
}

/* ===================== HOW IT WORKS ===================== */
function HowItWorks() {
  const { lang } = useParams();        // <-- текущий язык из URL
  const currentLang = lang || 'ru';    // fallback
  const { t } = useTranslation();
  return (
    <section id="how">
      <Container className="py-12">
        <Reveal>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('ButtonMP8')}</h2>
        </Reveal>
        <div className="mt-6 grid gap-6 md:grid-cols-2">
          <Reveal>
            <Card>
              <div className="text-xs font-semibold uppercase tracking-wider text-indigo-600">{t('Subheader36')}</div>
              <ol className="mt-3 grid gap-3 text-sm sm:grid-cols-2">
                <Step n={t('StepAu1')} t={t('Subheader361')} d={t('Step11')} />
                <Step n={t('StepAu2')} t={t('Subheader362')} d={t('Step21')} />
                <Step n={t('StepAu3')} t={t('Subheader363')} d={t('Step31')} />
                <Step n={t('StepAu4')} t={t('Subheader364')} d={t('Step41')} />
              </ol>
              <div className="mt-4">
                <a 
                href={`/${currentLang}/login`}
                className="inline-flex items-center justify-center rounded-2xl px-5 py-3 text-sm font-semibold text-white bg-gradient-to-r from-purple-600 to-indigo-600 hover:opacity-90 transition shadow-[0_12px_40px_rgba(24,24,27,.08)]">{t('ButtonMP5')}</a>
              </div>
            </Card>
          </Reveal>
          <Reveal>
            <Card>
              <div className="text-xs font-semibold uppercase tracking-wider text-indigo-600" id="for-authors">{t('Subheader37')}</div>
              <ol className="mt-3 grid gap-3 text-sm sm:grid-cols-2">
                <Step n={t('StepAu1')} t={t('Subheader371')} d={t('StepAu11')} />
                <Step n={t('StepAu2')} t={t('Subheader372')} d={t('StepAu21')} />
                <Step n={t('StepAu3')} t={t('Subheader373')} d={t('StepAu31')} />
                <Step n={t('StepAu4')} t={t('Subheader374')} d={t('StepAu41')} />
              </ol>
              <div className="mt-4">
                <a id="publish" href="#publish-form" className="inline-flex items-center justify-center rounded-2xl px-5 py-3 text-sm font-semibold text-white bg-gradient-to-r from-purple-600 to-indigo-600 hover:opacity-90 transition shadow-[0_12px_40px_rgba(24,24,27,.08)]">{t('ButtonMP6')}</a>
              </div>
            </Card>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}

function Step({ n, t, d }) {
  return (
    <li className="rounded-2xl border bg-gray-50 p-4">
      <div className="text-xs text-gray-500">{n}</div>
      <div className="font-semibold">{t}</div>
      <p className="mt-1 text-gray-600">{d}</p>
    </li>
  );
}

/* ===================== CATALOG TEASER ===================== */
function CatalogTeaser() {
  const { t } = useTranslation();
  return (
    <section id="catalog">
      <Container className="pb-12">
        <Reveal>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('Header28')}</h2>
        </Reveal>
        <Reveal>
          <div className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <Category title={t('MPCategory11')} text={t('MPCategory12')} />
            <Category title={t('MPCategory21')} text={t('MPCategory22')} />
            <Category title={t('MPCategory31')} text={t('MPCategory32')} />
          </div>
        </Reveal>
        <Reveal>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <a href="#publish-form" className="inline-flex items-center justify-center rounded-2xl px-6 py-3 text-base font-semibold text-white bg-gradient-to-r from-purple-600 to-indigo-600 hover:opacity-90 transition shadow-[0_12px_40px_rgba(24,24,27,.08)]">{t('ButtonMP7')}</a>
            <a href="#how" className="inline-flex items-center justify-center rounded-2xl px-6 py-3 text-base font-semibold bg-gray-900/5 hover:bg-gray-900/10 transition">{t('ButtonMP8')}</a>
          </div>
        </Reveal>
      </Container>
    </section>
  );
}

function Category({ title, text }) {
  const { t } = useTranslation();
  return (
    <div className="rounded-2xl border border-gray-200 bg-gray-50 p-5">
      <div className="text-xs text-gray-500">{t('MPCategory3')}</div>
      <div className="mt-1 font-semibold">{title}</div>
      <p className="mt-1 text-sm text-gray-600">{text}</p>
    </div>
  );
}

/* ===================== TRUST ===================== */
function Trust() {
  const { t } = useTranslation();
  return (
    <section id="trust">
      <Container className="pb-12">
        <Reveal>
          <Card className="md:p-8">
            <div className="grid gap-6 md:grid-cols-3">
              <TrustItem title={t('MPCategory4')} text={t('MPCategory41')} />
              <TrustItem title={t('MPCategory5')} text={t('MPCategory51')} />
              <TrustItem title={t('MPCategory6')} text={t('MPCategory61')} />
            </div>
          </Card>
        </Reveal>
      </Container>
    </section>
  );
}

function TrustItem({ title, text }) {
  return (
    <div>
      <h3 className="font-semibold">{title}</h3>
      <p className="mt-1 text-sm text-gray-700">{text}</p>
    </div>
  );
}

/* ===================== CASE TEMPLATE ===================== */
function CaseTemplate() {
  const { t } = useTranslation();
  return (
    <section id="cases">
      <Container className="pb-12">
        <Reveal>
          <Card className="md:p-8">
            <div className="grid items-start gap-6 md:grid-cols-5">
              <div className="md:col-span-2">
                <h2 className="text-2xl font-bold tracking-tight">{t('Header29')}</h2>
                <p className="mt-2 text-gray-700">{t('MPCategory7')}</p>
                <ul className="mt-4 list-disc pl-5 text-sm text-gray-700">
                  <li>{t('MPCategory71')}</li>
                  <li>{t('MPCategory72')}</li>
                  <li>{t('MPCategory73')}</li>
                </ul>
              </div>
              <div className="md:col-span-3 grid gap-3 text-sm sm:grid-cols-3">
                <Metric title={t('MPMetric11')} text={t('MPMetric12')} />
                <Metric title={t('MPMetric21')} text={t('MPMetric22')} />
                <Metric title={t('MPMetric31')} text={t('MPMetric32')} />
              </div>
            </div>
          </Card>
        </Reveal>
      </Container>
    </section>
  );
}

function Metric({ title, text }) {
  const { t } = useTranslation();
  return (
    <div className="rounded-2xl border bg-gray-50 p-4">
      <div className="text-xs text-gray-500">{t('MPMetric3')}</div>
      <div className="font-semibold">{title}</div>
      <p className="mt-1 text-gray-600">{text}</p>
    </div>
  );
}

/* ===================== TESTIMONIALS ===================== */
function Testimonials() {
  const { t } = useTranslation();
  return (
    <section>
      <Container className="pb-12">
        <Reveal>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('Header30')}</h2>
        </Reveal>
        <div className="mt-6 grid gap-4 md:grid-cols-2">
          <Reveal>
            <blockquote className="rounded-3xl border border-gray-200 bg-white p-6">
              <p className="text-gray-800">{t('MPReviews1')}</p>
              <footer className="mt-3 text-sm text-gray-500">{t('MPReviews11')}</footer>
            </blockquote>
          </Reveal>
          <Reveal>
            <blockquote className="rounded-3xl border border-gray-200 bg-white p-6">
              <p className="text-gray-800">{t('MPReviews2')}</p>
              <footer className="mt-3 text-sm text-gray-500">{t('MPReviews21')}</footer>
            </blockquote>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}

/* ===================== REFERRAL ===================== */
function Referral() {
  const { t } = useTranslation();
  const [authors, setAuthors] = useState(10);
  const [avgCheck, setAvgCheck] = useState(50_000);
  const [percent, setPercent] = useState(10);

  const monthly = useMemo(() => {
    const pct = Math.max(0, Math.min(100, percent)) / 100;
    // Примерная модель из исходника:
    // доход = (авторы*avg*0.5 + клиенты*avg*1) * pct / 12
    const m = authors * avgCheck * pct;
    return isFinite(m) ? Math.max(0, m) : 0;
  }, [authors, avgCheck, percent]);

  const scenario = t('MLCalcP7')
  // const scenario = `Сценарий: ${authors} автор(ов) и ${clients} клиент(ов) при среднем чеке ${avgCheck.toLocaleString("ru-RU")} ₽ и ${Math.round(percent)}% → ~ ${Math.round(monthly).toLocaleString("ru-RU")} ₽ / мес.`;

  return (
    <section id="ref">
      <Container className="pb-12">
        <Reveal>
          <Card className="md:p-8">
            <div className="grid gap-8 lg:grid-cols-2">
              <div>
                <h2 className="text-2xl font-bold tracking-tight">{t('Header31')}</h2>
                <p className="mt-2 text-gray-700">
                  <Trans 
                  i18nKey="MPCategory8"
                  components={{strong: <strong />}}
                  />
                </p>
                <ul className="mt-4 list-disc pl-5 text-sm text-gray-700">
                  <li>{t('MPCategory81')}</li>
                  <li>{t('MPCategory82')}</li>
                  <li>{t('MPCategory83')}</li>
                </ul>
              </div>
              <div>
                <div className="rounded-2xl bg-gray-50 p-5">
                  <h3 className="font-semibold">{t('MLCalc')}</h3>
                  <div className="mt-3 grid gap-4 text-sm sm:grid-cols-2">
                    <LabelledInput label={t('MLCalcP1')} type="number" min={0} value={authors} onChange={(v)=>setAuthors(Number(v))} />
                    <LabelledInput label={t('MLCalcP3')} type="number" min={0} step={10000} value={avgCheck} onChange={(v)=>setAvgCheck(Number(v))} />
                    <LabelledInput label={t('MLCalcP4')} type="number" min={1} max={50} value={percent} onChange={(v)=>setPercent(Number(v))} />
                  </div>
                  <div className="mt-4 text-sm text-gray-700">{t('MLCalcP5')} <span className="font-bold">{Math.round(monthly).toLocaleString("ru-RU")} ₽</span> {t('MLCalcP6')}</div>
                  <p className="mt-2 text-xs text-gray-500">{scenario}</p>
                </div>
              </div>
            </div>
          </Card>
        </Reveal>
      </Container>
    </section>
  );
}

function LabelledInput({ label, onChange, ...rest }) {
  return (
    <label className="flex flex-col">
      {label}
      <input {...rest} onChange={(e)=>onChange(e.target.value)} className="mt-1 rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-600" />
    </label>
  );
}

/* ===================== {t('linkMP5')} ===================== */
function Faq() {
  const { t } = useTranslation();
  const qna = [
  [t('MP_FAQ1'), t('MP_FAQ11')],
  [t('MP_FAQ2'), t('MP_FAQ21')],
  [t('MP_FAQ3'), t('MP_FAQ31')],
  [t('MP_FAQ4'), t('MP_FAQ41')],
];

  return (
    <section id="faq">
      <Container className="pb-14 max-w-5xl">
        <Reveal>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{t('Header49')}</h2>
        </Reveal>
        <Reveal>
          <div className="mt-6 overflow-hidden rounded-3xl border border-gray-200 divide-y divide-gray-200">
            {qna.map(([q, a]) => (
              <details key={q} className="group open:bg-gray-50">
                <summary className="flex cursor-pointer select-none items-start justify-between gap-4 p-5 hover:bg-gray-50">
                  <span className="font-semibold text-gray-900">{q}</span>
                  <span className="text-gray-400 transition group-open:rotate-45">＋</span>
                </summary>
                <div className="px-5 pb-5 text-sm text-gray-700">{a}</div>
              </details>
            ))}
          </div>
        </Reveal>
      </Container>
    </section>
  );
}

/* ===================== FOOTER ===================== */
function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-gray-100">
      <Container className="flex flex-col items-start justify-between gap-4 py-8 text-sm text-gray-500 sm:flex-row">
        <div>© {year} {t('MP_ref1')}</div>
        <div className="flex gap-6">
          <a href={footerDoc2} download={`${t('$UserAgr')}.docx`} style={{textDecoration: 'none', color: 'black'}} className="hover:text-gray-700">
              <p>
                  {t('$UserAgr')}
              </p>
          </a>
          <a href={footerDoc1} download={`${t('$Pol')}.docx`} style={{textDecoration: 'none', color: 'black'}} className="hover:text-gray-700">
              <p>
                  {t('$Pol')}
              </p>
          </a>
          <a className="hover:text-gray-700" href="#">{t('linkOLBP6')}</a>
        </div>
      </Container>
    </footer>
  );
}

/* ===================== FLOATING CTA ===================== */
function FloatingCTA() {
  const { t } = useTranslation();
  return (
    <div className="fixed right-4 bottom-4 z-60">
      <a href="#catalog" className="rounded-full bg-gradient-to-r from-purple-600 to-indigo-600 px-5 py-3 text-sm font-semibold text-white shadow-[0_12px_40px_rgba(24,24,27,.08)] hover:opacity-90 transition">{t('ButtonMP3')}</a>
    </div>
  );
}